import {Badge} from '@mantine/core'

import {quoteStatusColor} from 'src/theme/semantic-colors'

import type {QuoteStatus} from './schemas'

const STATUS_LABELS: Record<QuoteStatus, string> = {
    draft: 'Draft',
    sent: 'Sent',
    accepted: 'Accepted',
    rejected: 'Rejected',
    voided: 'Voided',
}

export function quoteStatusLabel(status: QuoteStatus): string {
    return STATUS_LABELS[status]
}

export {quoteStatusColor}

type QuoteStatusBadgeProps = {
    status: QuoteStatus
    variant?: 'filled' | 'light'
}

export function QuoteStatusBadge({status, variant = 'light'}: QuoteStatusBadgeProps) {
    return (
        <Badge color={quoteStatusColor(status)} variant={variant}>
            {quoteStatusLabel(status)}
        </Badge>
    )
}
